<script setup lang="ts">
import AsidePanel from "@/components/layout/AsidePanel.vue";
</script>

<template>
  <div class="main-layout">
    <AsidePanel />
    <div class="main-layout__content">
      <RouterView />
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-layout {
  display: flex;
  height: 100%;
  width: 100%;
  background-color: var(--background-bg-main);

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 30px;
  }
}
</style>